import React, { useEffect, useState, useRef, useMemo } from 'react';
import { Button, Col, Form, Input, Row } from 'antd';
import PropTypes from 'prop-types';

import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import {
  getAdvisorById,
  getQRCodeAttachBankID,
  getQRCodeSignBankID,
} from '../../../data/store/user/userActions';
import api from '../../../utils/API';
import { API_URLS } from '../../../constants/api_urls';
import ModalVerifyPersonalNumber from '../../../components/ModalVerifyPersonalNumber/ModalVerifyPersonalNumber';

// import { ReactComponent as BanckID } from '../../../assets/banckId-icon.svg';
import banckID from '../../../assets/bankID-icon.png';
import './style.scss';

const BanckID = () => {
  return (
    <div className="banckID-img">
      <img src={banckID} alt="" />
    </div>
  );
};

const PersonalNumberRow = ({ value, successAlert }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation('');
  // const [, forceUpdate] = useState({});
  const [pnumber, setPnumber] = useState(null);
  const [openBankId, setOpenBankId] = useState(false);
  const [codeQR, setCodeQR] = useState('');
  const id = useSelector((state) => state.userReducer.advisor.id);
  const { codeBankID } = useSelector((state) => state.userReducer);
  const isCollectingRef = useRef(false);

  // eslint-disable-next-line no-undef
  const baseUrl = process.env.REACT_APP_BASE_URL;

  const offsetStart = useRef(null);

  // useEffect(() => {
  //   forceUpdate({});
  // }, []);
  const diffTime = useMemo(() => {
    if (codeBankID?.before_time) {
      const diff = codeBankID.before_time - offsetStart.current;
      console.log('🚀 ~ code ~ diff:', diff);
      return diff;
    } else return 0;
  }, [offsetStart, codeBankID]);

  useEffect(() => {
    if (codeBankID?.qrs?.length > 0 && openBankId) {
      renderCode();
    }
  }, [codeBankID, openBankId]);

  const [intervalID, setIntervalID] = useState(null);

  useEffect(() => {
    return () => {
      if (intervalID) {
        clearInterval(intervalID);
      }
    };
  }, [intervalID]);

  const verifyByBankId = () => {
    if (pnumber && id) {
      offsetStart.current = Date.now();
      console.log('🚀 ~ getCode ~ offsetStart:', offsetStart.current);
      dispatch(getQRCodeAttachBankID(pnumber));
      setOpenBankId(true);
    }
  };

  const collect = async () => {
    const resp = await api.get(
      `${API_URLS.SIGN_COLLECT_ATTACH}?order_ref=${codeBankID.order_ref}`,
    );
    let data;
    resp.status === 200 ? (data = resp.data) : (data = { status: 'error' });
    return data;
  };
  const stopCollect = async () => {
    const resp = await api.post(`${baseUrl}${API_URLS.BANKID_CANCEL_COLLECT}`, {
      order_ref: codeBankID.order_ref,
    });
    return resp.data;
  };

  const renderCode = () => {
    const idInt = setInterval(code, 1000);
    setIntervalID(idInt);

    async function code() {
      let startIndex = Math.floor(
        (Date.now() + diffTime - codeBankID.start_time) / 1000,
      );
      console.log('🚀 ~ code ~ startIndex:', startIndex);
      console.log(
        '🚀 ~ startIndex Old Method:',
        Math.floor((Date.now() - codeBankID.start_time) / 1000),
      );

      if (isCollectingRef.current) {
        return;
      }

      if (startIndex > codeBankID.qrs?.length - 1 || !openBankId) {
        dispatch({ type: 'CLEAR_QR_BANKID' });
        clearInterval(idInt);
        setIntervalID(null);
        !openBankId ? setCodeQR('') : setCodeQR('Try again');
        isCollectingRef.current = false;
        if (openBankId) {
          successAlert({ value: t('ALERT_ERROR'), type: 'error' });
        }
      } else if (codeBankID?.qrs?.length) {
        isCollectingRef.current = true;
        const res = await collect();
        isCollectingRef.current = false;

        if (res?.hint_code === 'userSign') {
          setCodeQR('wait finger');
        } else if (!res?.hint_code && res?.status === 'complete') {
          successAlert({ value: t('ALERT_ERROR'), type: 'success' });
          clearInterval(idInt);
          setIntervalID(null);
          setOpenBankId(false);
          setCodeQR('');
          dispatch(getAdvisorById());
        } else if (
          res?.status === 'forbiden' ||
          res?.status === 'error' ||
          res?.status === 'failed'
        ) {
          successAlert({ value: t('ALERT_ERROR'), type: 'error' });
          clearInterval(idInt);
          setIntervalID(null);
          setOpenBankId(false);
          setCodeQR('Try again');
        } else setCodeQR(codeBankID.qrs[startIndex]);
      }
    }
  };
  const closeBankID = () => {
    setOpenBankId(false);
    setCodeQR('');
    if (codeBankID.order_ref) stopCollect();
    clearInterval(intervalID);
    setIntervalID(null);
    dispatch({ type: 'CLEAR_QR_BANKID' });
    isCollectingRef.current = false;
  };
  const restartSign = () => {
    if (!intervalID) dispatch(getQRCodeSignBankID(pnumber));
  };

  const hendleChangeValue = (event) => {
    const { value } = event.target;
    setPnumber(value);
  };

  return (
    <>
      <Row
        justify={'space-between'}
        align={'middle'}
        style={{ maxWidth: '1128px', marginBottom: '0', padding: '0' }}
      >
        <Col style={{ display: 'flex', alignItems: 'center', gap: '48px' }}>
          <h2 className="client setting-header-title">
            {t('PERSONAL_NUMBER')}
          </h2>
          <Form.Item
            style={{ marginBottom: '0' }}
            className="custom-required"
            maxLength={50}
            required={false}
          >
            <Input
              disabled={value}
              value={value || pnumber}
              onChange={hendleChangeValue}
              className="client custom-input"
            />
          </Form.Item>
        </Col>

        {!value && (
          <Button
            type="text"
            icon={<BanckID />}
            iconPosition="start"
            onClick={verifyByBankId}
            className={
              pnumber
                ? 'client profile-bankid-btn'
                : 'client profile-bankid-btn disabled'
            }
          >
            {t('CONFIRM_BANKID')}
          </Button>
        )}
      </Row>
      <ModalVerifyPersonalNumber
        closeBankID={closeBankID}
        codeQR={codeQR}
        openBankId={openBankId}
        restartSign={restartSign}
      />
    </>
  );
};

export default PersonalNumberRow;

PersonalNumberRow.propTypes = {
  value: PropTypes.string,
  handleDeleteValue: PropTypes.func,
  successAlert: PropTypes.func,
};
